import React from "react";

export default function LoadIndicator({ isOpaque = false }) {
  return <p className="loader m-0" />;
}

export const OverlayLoader = () => {
  return (
    <div className="pre-loader-wrapper show">
      <div className="d-flex flex-column align-items-center gap-3">
        <img className="icon max-h-120 img-fluid h-100 mb-3" src="/ogImage.png" alt="FeelingHub" />
        <div className="loading-bar"></div>
      </div>
    </div>
  );
};
